import { useState, ChangeEvent } from "react";
import Button from "Components/Button";
import Input from "Components/Input";
import { Wrapper, ItemWrapper } from "./JobsFilter.styled";
import DropDown from "Components/DropDown";

const JobsFilter = () => {
  const [state, setState] = useState({
    distance: "5 ",
    job: "",
    location: "",
  });

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const url = `https://www.new-job-today.co.uk/searchjobs/?Keywords=${state.job}&radialtown=${state.location}&RadialLocation=${state.distance}`;
    window.open(url, "_blank");
  };
                
  const handleSelectItem = (type: string, item: any) => {
    setState({ ...state, [type]: item });
  };
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setState({ ...state, [e.target.name]: e.target.value });
  };

  return (
    <Wrapper onSubmit={handleSubmit}>
      <ItemWrapper>
        <p>what</p>{" "}
        <Input name="job" handleChange={handleChange} value={state.job} />
      </ItemWrapper>
      <ItemWrapper>
        <p>where</p>{" "}
        <Input
          name="location"
          value={state.location}
          handleChange={handleChange}
        />
      </ItemWrapper>
      <ItemWrapper>
        <DropDown
          col={1}
          title={`Within ${state.distance} miles`}
          value={state.distance}
        >
          {[0, 5, 10, 15, 20]?.map((item, i) => {
            return (
              <div
                key={i}
                onClick={() => handleSelectItem("distance", item)}
                className="catagory_item"
              >
                Within {item} miles
              </div>
            );
          })}
        </DropDown>
      </ItemWrapper>
      <ItemWrapper>
        <Button
          disabled={
            state.distance === "" || state.job === "" || state.location === ""
          }
          buttonType="submit"
          buttonStyles="primary"
        >
          Search
        </Button>
      </ItemWrapper>
    </Wrapper>
  );
};

export default JobsFilter;
